
import { mapGetters } from "vuex";
import BrandAvatarWithColor from "../common/brand-avatar-with-color.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: {
    ResponsiveDialog,
    BrandAvatarWithColor
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("restaurant", ["getAllBrands"])
  }
};
